import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Col, Button, Row, ButtonToolbar } from 'react-bootstrap';
import { proposalOperations, proposalSelectors } from "./state";
import { EMPTY_STRING, MAX_DB_DATE_EXACT, MIN_DB_DATE_EXACT, ERROR, EMPTY_COUNT, NUMBER, MAX_INT, DATE_FORMAT, REGEX_NUMERIC, ERROR_PARTNER_CONFLICT } from '../../../utils/constants';
import FormTemplate from '../../components/FormTemplate';
import { EDIT_PROPOSAL, PROPOSALS } from './routes';
import { isNullOrUndefined } from '../../../../node_modules/util';
import { ERROR_PROPOSAL_NOT_EXIST, ERROR_BP_CREATE, ERROR_BP_RETRIEVE, ERROR_SINGLE_DATE_CONFLICT } from '../../../utils/messages';
import ErrorAlert from '../../components/ErrorAlert';
import moment from 'moment';
import ContainerTableTemplate from '../../components/ContainerTableTemplate';

class AddProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partnerList: [],
            proposalId: EMPTY_STRING,
            customerCode1: EMPTY_STRING,
            customerCode2: EMPTY_STRING,
            customerName: EMPTY_STRING,
            customerKana: EMPTY_STRING,
            proposalStartDate: MIN_DB_DATE_EXACT,
            proposalEndDate: MAX_DB_DATE_EXACT,
            rerender: true,
            error: []
        };
    }

    componentWillMount() {
        let id = this.props.match.params.id;

        if (undefined !== id) {
            if(undefined === this.props.location.state){
                this.props.history.push(PROPOSALS);
            }

            this.props.view(id).then((result) => {
                if (null === result.data) {
                    this.setState({ error: [ERROR_PROPOSAL_NOT_EXIST], invalidProposal: true, isUpdateAllowed: false });
                } else {
                    let proposal = result.data.details;

                    this.setState({
                        proposalId: id,
                        proposalStartDate: moment(proposal.proposalStartDate).format(DATE_FORMAT),
                        proposalEndDate: moment(proposal.proposalEndDate).format(DATE_FORMAT)
                    });
                }
            });
        }
    }

    filterList = (filter) => {
        this.setState({rerender: true}, ()=>{
            this.props.filterPartnerList(filter).then((result) => {
                if (ERROR === result.status) {
                    this.setState({ error: [result.message] });
                } else {
                    this.setState({ partnerList: result.data });
                }
            }).catch(()=>this.setState({ error: [ERROR_BP_RETRIEVE] }));
        })
    }

    setFilter = () => {
        let errorList = proposalSelectors.validateAddPartnerForm(this.state);
        
        if (EMPTY_COUNT < errorList.length) {
            this.setState({ error: errorList });
        }else{
            let filter = {
                proposalId: this.state.proposalId,
                customerCode1: this.state.customerCode1,
                customerCode2: this.state.customerCode2,
                customerName: this.state.customerName,
                customerKana: this.state.customerKana,
                proposalStartDate: this.state.proposalStartDate,
                proposalEndDate: this.state.proposalEndDate
            }

            this.filterList(filter);
        }
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    handleDateChange = (name, customFormat, date) => {
        if (!isNullOrUndefined(date)) {
            let formatDate = date.format(customFormat)
            this.setState({ [name]: formatDate })
        }
    }

    handleInputChange = (event) => {
        this.setState({rerender: false});
        if(NUMBER !== event.target.type || (NUMBER === event.target.type && MAX_INT > event.target.value && event.target.value.match(REGEX_NUMERIC))){
            this.setState({ [event.target.name]: event.target.value });
        }
    }

    showProposal = () => {
        this.props.history.push(EDIT_PROPOSAL + "/" + this.state.proposalId);
    }

    insertPartner = (row) => {

        this.props.checkPartnerConflict(row.customerCode1, row.customerCode2, this.state.proposalStartDate, this.state.proposalEndDate)
        .then((result)=>{

            if (EMPTY_COUNT < result.data.conflicts.length) {
                this.printConflicts(result.data.conflicts);
            }else{
                this.setState({ error: [] });
                
                let details = {
                    proposalId: this.state.proposalId,
                    customerCode1: row.customerCode1,
                    customerCode2: row.customerCode2,
                    strProposalStartDate: this.state.proposalStartDate,
                    strProposalEndDate: this.state.proposalEndDate
                }
        
                this.props.insertPartner(details, this.props.user.user_cd).then((result)=>{
                    if (ERROR === result.status) {
                        if(ERROR_PARTNER_CONFLICT === result.message){
                            this.printConflicts(JSON.parse(result.data));
                        }else{
                            this.setState({ error: [result.message] });
                        }
                    } else {
                        this.showProposal();
                    }
                }).catch(()=>this.setState({ error: [ERROR_BP_CREATE] }));
            }
        }).catch(()=>this.setState({ error: [ERROR_BP_CREATE] }));
    }

    printConflicts = (list) =>{
        let prompt = [];
        prompt.push(ERROR_SINGLE_DATE_CONFLICT);
        list.map((item) => prompt.push("* " + item.proposalName));
    
        this.setState({ error: prompt, success: [] });
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ErrorAlert errors={this.state.error}/>

                    <Row className="custom-flex-end">
                        <Col xs={5} >
                            <FormTemplate
                                xs={true}
                                {...this.props}
                                {...this.state}
                                proposalDates={true}
                                handleDateChange={this.handleDateChange}
                                handleDateChangeRaw={this.handleDateChangeRaw}
                                className="partner-form"
                                horizontal={true}
                                handleInputChange={this.handleInputChange}
                            />
                        </Col>
                        <ButtonToolbar className="add-toolbar-style">
                            <Button
                                className="button-common mb-1"
                                onClick={() => this.setFilter()}>
                                {"検索"}
                            </Button>
                            <Button
                                className="button-common mb-1"
                                onClick={() => this.showProposal()}>
                                {"戻る"}
                            </Button>
                        </ButtonToolbar>
                    </Row>

                    <ContainerTableTemplate
                        {...this.props}
                        tableName={"partnerTable"}
                        rerender = {this.state.rerender}
                        tableList={this.state.partnerList}
                        rowButtons={[
                            {
                                onClick: this.insertPartner,
                                icon: "plus-circle",
                                bsStyle: "link"
                            }
                        ]}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.credentials,
        formInputs: state.proposal.addPartnerForm,
        tableHeader: state.proposal.addPartnerTableHeader,
        tableColumns: state.proposal.addPartnerTableColumns
    }
};

const mapDispatchToProps = {
    view: proposalOperations.viewProposal,
    filterPartnerList: proposalOperations.filterPartnerList,
    insertPartner: proposalOperations.insertPartner,
    checkPartnerConflict: proposalOperations.checkPartnerConflict
};

export default connect(mapStateToProps, mapDispatchToProps)(AddProduct);